import { ROOT_ELEMENT_ID } from '@nvd/claim-shared';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/index.scss';

function mount(root: HTMLElement): void {
  if (root.dataset.nvdMounted) return;
  root.dataset.nvdMounted = 'true';
  root.classList.add('nvd-claim-portal');
  createRoot(root).render(<App root={root} />);
}

document.querySelectorAll<HTMLElement>(`#${ROOT_ELEMENT_ID}, [data-nvd-claim-portal]`).forEach(mount);
